'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiListItem, {
  type ListItemTypeMap as MuiListItemTypeMap,
} from '@mui/material/ListItem';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type ListItemTypeMap<P = CustomProps, D extends ElementType = 'li'> = {
  defaultComponent: D;
  props: Omit<MuiListItemTypeMap<P, D>['props'], ExcludedMuiProps> & P;
};

/**
 * @deprecated Please use `List.Item`` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type ListItemProps<
  D extends ElementType = 'li',
  P = CustomProps,
> = OverrideProps<ListItemTypeMap<P, D>, D>;

const ListItemComponent = <D extends ElementType = 'li'>(
  props: ListItemProps<D>,
  ref: Ref<HTMLLIElement>
) => {
  return <MuiListItem {...props} ref={ref} />;
};

ListItemComponent.displayName = 'ListItem';

/**
 * @deprecated Please use `List.Item` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItem = forwardRef(
  ListItemComponent
) as OverridableComponent<ListItemTypeMap>;
